import { render, staticRenderFns } from "./GlobalVariables.vue?vue&type=template&id=e5f47274&"
import script from "./GlobalVariables.vue?vue&type=script&lang=js&"
export * from "./GlobalVariables.vue?vue&type=script&lang=js&"
import style0 from "./GlobalVariables.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports